import { useState } from 'react';
import { smoothNavigate } from '../utils/smoothNavigation';

export const useTeamHubNavigation = () => {
  const [isNavigating, setIsNavigating] = useState(false);

  const returnToTeamHub = async () => {
    setIsNavigating(true);
    
    try {
      // Navigate to team member dashboard instead of homepage
      await smoothNavigate('/team-member-dashboard', { 
        clearSelectedArtist: true,
        fadeOutDuration: 200,
        delay: 50
      });
    } catch (error) {
      console.error('Navigation error:', error);
      // Fallback to direct navigation to team member dashboard
      localStorage.removeItem('selectedArtist');
      window.location.href = '/team-member-dashboard';
    }
  };

  return { isNavigating, returnToTeamHub };
};

export default useTeamHubNavigation; 